"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormConfig = /** @class */ (function () {
    function FormConfig(json) {
        this.json = json;
    }
    FormConfig.prototype.getForms = function () {
        var _this = this;
        var forms = {};
        Object.values(this.json.forms).forEach(function (formConfig) {
            // Ingore private items
            if (!formConfig.id) {
                return;
            }
            var _a = formConfig.id.split('.'), group = _a[0], id = _a[1];
            var form = _this.getForm(formConfig);
            if (form) {
                forms[group] = forms[group] || {};
                forms[group][id] = form;
            }
        });
        return forms;
    };
    FormConfig.prototype.getForm = function (formConfig) {
        var form = Object.assign({}, formConfig);
        form.options = this.getOptions(formConfig.options);
        return form;
    };
    FormConfig.prototype.getOptions = function (optionsConfig) {
        return optionsConfig.map(function (config) {
            var option = Object.assign({}, config);
            if (config.condition === undefined) {
                option.condition = true;
            }
            else {
                option.$condition = config.condition;
            }
            return option;
        });
    };
    return FormConfig;
}());
exports.default = FormConfig;
